import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import List from "./list";
import Show from "./show";

const Dictionaries = (props) => {
    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route exact path={rootUrl} render={() => <List {...props} isTable title="Справочники" nofilter />} />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => <Show {...rest} transition="full" title="Изменение справочника" back={back} />}
                />
            </Switch>
        </div>
    );
};

export default Dictionaries;
